<script>
  import { Line, mixins } from 'vue-chartjs'
  const { reactiveProp } = mixins

  export default {
    extends: Line,
    mixins: [reactiveProp],
    props: {
      chartData: {
        type: Object,
        default: {}
      },  
    },
    data() {
      return {
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {        
            xAxes: [{
              display: true,
              scaleLabel: {
                display: true,                
              },
              ticks: {
                beginAtZero: true,
                max: 100
              }               
            }],                    
            yAxes: [{
              display: true,
              scaleLabel: {
                display: true,
              },                            
              ticks: {
                beginAtZero: true,
                max: 100,
                callback: function(value, index, values) {
                    return value + ' %';
                }
              }
            }]
          }
        }
      }
    },
    mounted () {        
      this.render()
    },
    watch: {
      chartData: function() {
        this.$data._chart.update()
      },
    }, 
    methods: {
      render() {
        this.renderChart(this.chartData, this.options) 
      }
    }
  }
</script>
